'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'far';
var iconName = 'repeat';
var width = 512;
var height = 512;
var aliases = [128257];
var unicode = 'f363';
var svgPathData = 'M352 151c0 22.6 18.3 41 41 41 10.9 0 21.3-4.3 29-12l67-67c4.5-4.5 7-10.6 7-17s-2.5-12.5-7-17l-67-67c-7.7-7.7-18.1-12-29-12-22.6 0-41 18.3-41 41l0 31-160 0C86 72 0 158 0 264 0 277.3 10.7 288 24 288s24-10.7 24-24c0-79.5 64.5-144 144-144l160 0 0 31zm86.1-55L400 134.1 400 57.9 438.1 96zM119 512c22.6 0 41-18.3 41-41l0-31 160 0c106 0 192-86 192-192 0-13.3-10.7-24-24-24s-24 10.7-24 24c0 79.5-64.5 144-144 144l-160 0 0-31c0-22.6-18.3-41-41-41-10.9 0-21.3 4.3-29 12L23 399c-4.5 4.5-7 10.6-7 17s2.5 12.5 7 17l67 67c7.7 7.7 18.1 12 29 12zM73.9 416l38.1-38.1 0 76.1-38.1-38.1z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faRepeat = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;